import * as c from '../constants/TeacherConstants'

const initialState = {
  fetching: false,
  fetched: false,
  error: null,
  data: {},
}

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case c.FETCH_ORG_TEACHERS_PENDING:
      return { ...state, fetching: true, fetched: false }
    case c.FETCH_ORG_TEACHERS_FULFILLED:
      return {
        ...state,
        data: { ...state.data, [payload.orgId]: payload.data },
        fetching: false,
        fetched: true,
      }
    case c.FETCH_ORG_TEACHERS_REJECTED:
      return { ...state, fetching: false, fetched: false, error: payload }

    default:
      return state
  }
}
